import {
  Dialog,
  DialogContent,
  Button,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import React from "react";
import Http from "../Http";
import TableComponent, { TableOp } from "./table/TableOps";
import PDFViewer from "./pdfViewer";
import ACCESS from "../ACCESS";

class DigitalizacionesGuia extends TableComponent {
  componentDidMount() {
    // this.cargarLog();
    let pgId = this.props.guiaId;
    this.tableConfig(
      {
        dataUrl: `digitalizar/filter-guia/${pgId}`,
        deleteUrl: "digitalizar/delete",
        deleteField: "archivo",
        modUrl: "",
      },
      TableOp.Table(
        false,
        [
          {
            label: "Seleccionar",
            id: "check_download",
            type: "checkbox",
            callback: this.onSelectArchivo,
          },
          { label: "Archivo", id: "archivo" },
          { label: "Tipo", id: "tipo" },
          { label: "Descripcion", id: "descripcion" },
          { label: "Usuario", id: "usuario" },
          { label: "Fecha Creacion", id: "createdAt" },
        ],
        [
          { id: "show", icon: "visibility", access: [ACCESS.DIGITALIZAR.DESCARGAR_EVIDENCIA] },
          { id: "download", icon: "download", access: [ACCESS.DIGITALIZAR.DESCARGAR_EVIDENCIA] },
          { id: "delete", icon: "delete", access: [ACCESS.DIGITALIZAR.ELIMINAR_EVIDENCIA] },
        ]
      )
    );
    this.table();
  }

  componentDidUpdate(prevprops) {
    if (prevprops.guiaId !== this.props.guiaId) {
      this.config = {
        dataUrl: `digitalizar/filter-guia/${this.props.guiaId}`,
        deleteUrl: "digitalizar/delete",
        deleteField: "archivo",
        modUrl: "",
      };
      this.table();
    }
  }

  onSelectArchivo = (event, index, field) => {
    const { tableData } = this.state;
    let value = event.target.value;
    tableData.rows[index][field] = value;
    const selectedChecbox = tableData.rows.some((r) => r[field]);
    this.setState({ tableData, selectedChecbox });
  };

  action = (id, row, cb) => {
    if (id === "delete") {
      this.delete(row);
    } else if (id === "download") {
      this.downloadFiles([row.id]);
    } else if (id === "show") {
      this.showPdf(row.id);
    }
    this.setState({ row });
  };

  onMultipleDownload = async () => {
    const { tableData } = this.state;
    const archivos = tableData.rows.filter((r) => r.check_download);
    if (archivos && archivos.length > 0) {
      this.downloadFiles(archivos.map((a) => a.id));
    }
  };

  downloadFiles = async (idArchivo = []) => {
    const { tableData } = this.state;
    const Resp = await Http.get(
      `digitalizar/download?id=${idArchivo}`,
      true,
      "arraybuffer"
    );
    if (!Resp.error) {
      let blob = null;
      let filename = "";
      if (idArchivo.length > 1) {
        blob = new Blob([Resp], { type: "application/zip" });
        filename = `${this.props.guiaId}.zip`;
      } else {
        const archivoDownloaded = tableData.rows.find((r) =>
          idArchivo.includes(r.id)
        );
        blob = new Blob([Resp], { type: "application/pdf" });
        filename = `${archivoDownloaded.archivo}`;
      }
      const pdfURL = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = pdfURL;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(pdfURL);
    }
  };

  showPdf = async (idArchivo) => {
    this.setState({ loading: true });
    const Resp = await Http.get(
      `digitalizar/download?id=${idArchivo}`,
      true,
      "arraybuffer"
    );
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({
        pdfURL: URL.createObjectURL(blob),
        viewPdf: true,
        downloadZip: false,
        loading: false,
      });
    }
    this.setState({ loading: false });
  };

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
  };

  render() {
    const { selectedChecbox, viewPdf, pdfURL, row } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        {selectedChecbox && hasAccess([ACCESS.DIGITALIZAR.DESCARGAR_EVIDENCIA]) && (
          <Button
            variant="contained"
            color="primary"
            onClick={this.onMultipleDownload}
          >
            Descargar Seleccion
          </Button>
        )}
        <this.TableRender />

        {/* Modal visualizar impresion */}
        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"md"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            {pdfURL !== "" && (
              <div className="pdf-viewer">
                <PDFViewer
                  alert={(err) => (
                    <div
                      style={{
                        color: "#fa5b35",
                      }}
                    >
                      <h6>No hay guías en el embarque</h6>
                    </div>
                  )}
                  scale={1}
                  style={{ height: 400 }}
                  document={{
                    url: pdfURL,
                  }}
                  pdfUrl={pdfURL}
                />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewPdfClose}>Cancelar</Button>
            <Button
              variant="contained"
              onClick={() => {
                this.downloadFiles([row.id]);
              }}
            >
              Descargar Pdf
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default DigitalizacionesGuia